Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../../tokens");
exports.AzureTheme = {
    name: 'azure',
    appPrimaryColor: tokens_1.Azure[100],
    appSecondaryColor: tokens_1.Grey[100],
    appFontFamily: tokens_1.Fonts.Titillium,
};
//# sourceMappingURL=AzureTheme.js.map